import { render, staticRenderFns } from "./v-chart.vue?vue&type=template&id=09de492e&"
import script from "./v-chart.vue?vue&type=script&lang=js&"
export * from "./v-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports